var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.089,
    height: 75.127,
    viewBox: "0 0 75.089 75.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M3.062,72.863C2.03,71.846,7.405,61.372,7.105,59.489c-.1-.608-2.559-3.837-3.165-5.172C-14.986,12.641,38.935-19.519,66.525,13.891c24.027,29.1-6.517,71.837-42.07,58.84-2.338-.855-5.668-3.4-7.93-3.5-2.286-.1-12.8,4.287-13.463,3.63M44.808,48.125c-3.068,2.556-11.431-4.842-13.583-7.319-1.079-1.241-4.069-5.167-4.215-6.626-.32-3.21,3.653-3.725,3.634-7.133-.007-1.209-3.655-10.532-4.48-11.125C21.3,12.435,15.729,19.5,15.09,24.107,13.545,35.251,26.294,49.95,35.448,55.15c6.646,3.774,16.689,7.971,23.011,1.548,1.56-1.586,3.619-6.914,1.669-8.421-.937-.723-9.082-4.813-10.069-4.806-2.671.019-3.788,3.436-5.251,4.655",
    transform: "translate(0.001 -0.001)",
    fill: "#55ae4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M54.829,58.163c1.463-1.219,2.581-4.636,5.251-4.655.987-.007,9.133,4.083,10.069,4.806,1.95,1.507-.109,6.835-1.669,8.421-6.323,6.424-16.365,2.227-23.011-1.548-9.155-5.2-21.9-19.9-20.358-31.043.638-4.6,6.214-11.672,11.073-8.184.825.592,4.473,9.916,4.48,11.125.02,3.408-3.954,3.923-3.634,7.133.146,1.459,3.136,5.385,4.215,6.626,2.152,2.476,10.516,9.875,13.583,7.319",
    transform: "translate(-10.02 -10.038)",
    fill: "#fbfdfa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappImage);
export default __webpack_public_path__ + "static/media/whatsapp-image.b47d92dc2827344fcef80e1543dd91fd.svg";
export { ForwardRef as ReactComponent };